<script setup lang="ts">
defineProps<{
	name: string
	label: string
	modelValue?: string
	required?: boolean
}>()

defineEmits<{
	'update:modelValue': [value: string]
}>()
</script>

<template>
	<label class="c-textarea">
		<strong class="c-textarea__label">{{ label }}</strong>
		<textarea
			class="c-textarea__input"
			:name="name"
			:required="required"
			:value="modelValue"
			@input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
		/>
	</label>
</template>
